import styled from 'styled-components';

export const H3 = styled.h3`
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 700;
  width: 100%;
  text-align: center;
  font-family: GothamLight;
`;
